import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

interface HeroProps {
  heroTitle?: string | undefined | null
  image?: any | undefined | null
}

export const Hero = ({ heroTitle, image }: HeroProps) => {
  const [loaded, setLoaded] = useState<boolean>(false)

  return (
    <div className="grid grid-cols-1 md:grid-cols-[300px_52px_auto] lg:grid-cols-[400px_152px_auto] md:max-h-[32rem] mb-16 items-center">
      {heroTitle && (
        <p
          className={`-my-8 md:my-0 mx-4 order-2 md:order-1 md:mx-0 md:col-start-1 md:col-end-3 md:row-start-1 md:row-end-2 px-8 py-4 md:px-12 md:py-8 bg-secondary leading-snug md:leading-snug lg:leading-snug rounded shadow-2xl shadow-card text-white text-3xl md:text-4xl lg:text-6xl z-10 transition-all duration-500 delay-500 ${
            loaded
              ? 'translate-y-0 translate-x-0 opacity-1'
              : 'translate-y-10 translate-x-0 md:translate-y-0 md:-translate-x-40 opacity-0'
          }`}
          dangerouslySetInnerHTML={{ __html: heroTitle }}
        />
      )}

      {image && (
        <GatsbyImage
          className={`order-1 md:order-2 md:col-start-2 md:col-end-4 md:row-start-1 md:row-end-2 rounded transition-all duration-500 ${
            loaded
              ? 'translate-y-0 translate-x-0 opacity-1'
              : '-translate-y-10 translate-x-0 md:translate-y-0 md:translate-x-40 opacity-0'
          }`}
          image={image}
          alt=""
          onLoad={() => setLoaded(true)}
        />
      )}
    </div>
  )
}
